<template>
    <Layout>
      <b-row>
        <b-col cols="12">
          <Dashboard/>
        </b-col>
      </b-row > 
        <!--<b-row>
            <b-col cols="12">
                <b-button @click="$bvModal.show('applicantModal')">Applicant Modal</b-button>
            </b-col>
        <ApplicantModal />
        </b-row>
        -->
    </Layout>
</template>

<script>
//import ApplicantModal from '@/components/admin/applicantModal.vue';
import Dashboard from '@/components/admin/adminDashboard.vue';

import Layout from "../../layouts/main";
import appConfig from "@/app.config";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Clients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    //ApplicantModal,
    Dashboard,
  },
  data() {
    return {
        title: "Dashboard",
        items: [
            {
                text: "Dashboards",
                href: "/",
            },
            {
                text: "Default",
                active: true,
            },
        ],
    };
  },
  methods:{

  },
  mounted() {
    
  }
};
</script>

<style>

</style>


